var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.gb_enabled ? _c('div', {
    staticClass: "video-wrapper w-full"
  }, [_c('mux-player', {
    staticClass: "w-full",
    style: {
      'aspect-ratio': _vm.aspectRatio,
      'max-height': '60vh'
    },
    attrs: {
      "stream-type": "on-demand",
      "playback-id": _vm.playbackId,
      "thumbnail-time": "0.3",
      "metadata-video-title": _vm.title,
      "metadata-viewer-user-id": "user-id-007"
    }
  })], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };